import type { ReactNode } from 'react';

export interface IUser {
  id: string;
  create_date: string;
  update_date: string | null;
  login_date: string | null;
  name: string;
  login: string | null;
  role: UserRole | null;
  password: string;
  yandex_data: string | null;
  vk_data: string | null;
  disabled: boolean | null;
  active_tariff_purchases: IActiveTariff[];
  active_tariff_purchases_count: number;
  current_purchase_expires_at: string | null;
  ref: string | null;
  supervisor_online: boolean | null;
}

export type UserSelectItem = Pick<IUser, 'id' | 'name' | 'login'>;

export interface ITableColumn<T> {
  id: keyof T;
  title: string;
  sortable?: boolean;
  content?: (value: any) => ReactNode;
  align?: 'center';
}

export interface ITableData<T> {
  rows: T[];
  columns: ITableColumn<T>[];
  orderBy?: keyof T | undefined;
  order?: 'asc' | 'desc' | undefined;
}

export interface IActiveTariff {
  tariff_plan_id: string;
  tariff_plan_name: string;
  expires_at: string;
  remaining_balance: number;
}

export enum UserRole {
  ADMIN = 'ADMIN',
  DEFAULT_EXPERTS_MANAGER = 'DEFAULT_EXPERTS_MANAGER',
}

export type LoginRequest = { username: string; password: string };

export type LoginWithRequest = { access_token: string };

export type LoginResponse = {
  access_token: string;
  token_type: string;
};

export type RegisterRequest = Pick<IUser, 'name' | 'login' | 'password' | 'ref'>;

export type AuthConstants = {
  yandexId?: {
    clientId: string;
  };
  vkId?: {
    clientId: string;
  };
};

export interface YandexUser {
  // // СТандартный набор полей
  id: string; // "1130000067064841"
  login: string; // "svt.varina@nlabteam.com"
  client_id: string; // "77cf0e3c784644eda984e5f0143f79e2"
  psuid: string; // "1.AAAAAA.xwk5fOJTxop6mCmLOcqXUw.O02ZRmTl4WdgnDbvq1pR7A"

  // // Доступ к адресу эл почты
  default_email?: string; // "svt.varina@nlabteam.com",
  emails?: string[]; // [ "svt.varina@nlabteam.com" ]

  // // Доступ к портрету пользователя
  default_avatar_id?: string; // "15430/9FMOWvdGGx9FQcx9vP3PFpO5M9k-1",
  is_avatar_empty?: boolean; // false

  // // Доступ к логину, имени и фамилии, полу
  real_name?: string; // "Светлана Варина"
  display_name?: string; // "svt.varina@nlabteam.com"
  first_name?: string; // "\u0421\u0432\u0435\u0442\u043b\u0430\u043d\u0430"
  last_name?: string; // "\u0412\u0430\u0440\u0438\u043d\u0430"
  sex?: string; // "female" | "male" | null
}

export type VkLoginSuccessData = {
  code: string;
  device_id: string;
};

export type VkAuthCode = VkLoginSuccessData & {
  state: string;
  code_verifier: string;
};

export interface VkUser {
  user_id: string;
  first_name: string;
  last_name: string;
  avatar: string;
  email?: string;
  sex: number; // 1 - f, 2 - m, 0 - ?
  birthday: string;
  verified: boolean;
}
